import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlightStopCountPipe } from '../flight-stop-count/flight-stop-count.pipe';

@NgModule({
  declarations: [FlightStopCountPipe],
  imports: [CommonModule],
  exports: [FlightStopCountPipe]
})
export class FlightStopCountModule {}
